import { Button } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import Home from "./Home";
import { NavLink } from "react-router-dom";
import KwdcHeader from './LoginHeader';
import React, { useEffect } from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import PublicSiteFooter from './PublicSiteFooter';
// import KwdcHeader from './Header';

const gallery = [
    "../images/g1.jpeg",
    "../images/g2.jpeg",
    "../images/pic 5.JPG.jpeg",
    "../images/pic 8.JPG.jpeg",
    "../images/pic 11.JPG.jpeg",
    "../images/pic 17.JPG.jpeg",
    "../images/pic 16.JPG.jpeg",
];

const images = gallery.map((image) => ({
    thumb: image,
    full: image,
}));


export default function GalleryPage() {
    useEffect(() => {
        Fancybox.bind("[data-fancybox='gallery']", {
            Toolbar: {
                display: {
                    left: [],
                    middle: ["zoomIn", "zoomOut", "toggle1to1"],
                    right: ["slideshow", "thumbs", "close"],
                },
            },
        });

        return () => Fancybox.unbind("[data-fancybox='gallery']");
    }, []);
    return (
        <>
            <KwdcHeader />



            <section className="kwdc-innerpage-about-top mb-0">
                <Container fluid className="p-0">
                    <Row className="g-0">
                        <Col xxl={8} xl={8} lg={8} md={8} sm={9} xs={9} className="kwdc-innerpage-about-left">
                            <div className="kwdc-innerpage-about-heading">
                                <h1>Gallery</h1>
                                <p>
                                    A.P. State Kapu Welfare & Development
                                    Corporation
                                </p>
                            </div>
                        </Col>

                        <Col xxl={4} xl={4} lg={4} md={4} sm={3} xs={3} className="kwdc-about-right"></Col>
                    </Row>
                </Container>
            </section>



            {/* =======================================contact us=================================================== */}
            <section className="kwdc-contact-section">
                <Container>
                    <Row>
                        {images.map((image, index) => (
                            <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={12} className='mb-4'>

                                <a
                                    key={index}
                                    href={image.full}
                                    data-fancybox="gallery"
                                    className="gallery-item"
                                >
                                    <img src={image.thumb} alt={`Gallery ${index}`} />
                                </a>

                            </Col>
                        ))}
                    </Row>

                </Container>
            </section>

            <PublicSiteFooter />
        </>
    );
}







